module.exports = __webpack_public_path__ + "assets/study-mode-header.667dd311.svg";